window.addEventListener('load', function () {
    // Get the preloader element
    var preloader = document.getElementById('preloader-active');
    
    if (preloader) {
      // Set a timeout to fade out the preloader after 450ms delay
      setTimeout(function () {
        // Fade out the preloader by reducing opacity and removing it from view
        preloader.style.transition = 'opacity 0.6s ease-out';
        preloader.style.opacity = 0;
        
        // After 0.6s transition, hide the preloader completely
        setTimeout(function () {
          preloader.style.display = 'none';
        }, 600); // Time matching the fade-out duration
      }, 450); // Delay before the fade-out starts
  
      // Set body overflow to visible after the preloader is removed
      setTimeout(function () {
        document.body.style.overflow = 'visible';
      }, 450); // Same delay to avoid flickering
    }

  });
  

  document.addEventListener("DOMContentLoaded", function () {
    var owl = document.querySelector('.header-carousel');
    if (owl) {
      $(owl).owlCarousel({
        items: 1,
        loop: true,
        nav: true,
        dots: true,
        autoplay: true,
        smartSpeed: 500,
        navText: [
          '<i class="bi bi-arrow-left"></i>',
          '<i class="bi bi-arrow-right"></i>'
        ],
      });
    }
  });
  
  // testimonial carousel
  $(".testimonial-carousel").owlCarousel({
    autoplay: true,
    smartSpeed: 1500,
    center: false,
    dots: true,
    loop: true,
    margin: 25,
    nav : true,
    navText : [
        '<i class="fa fa-angle-right"></i>',
        '<i class="fa fa-angle-left"></i>'
    ],
    responsiveClass: true,
    responsive: {
        0:{
            items:1
        },
        576:{
            items:1
        },
        768:{
            items:2
        },
        992:{
            items:2
        },
        1200:{
            items:3
        }
    }
});


var swiper = new Swiper('.team-slider', {
    loop: true,
    slidesPerView: 4, // Default to 4 items on large screens
    spaceBetween: 30,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    breakpoints: {
      1200: {
        slidesPerView: 4, // 4 items on large screens (>= 1200px)
      },
      992: {
        slidesPerView: 3, // 3 items on medium screens (>= 992px)
      },
      776: {
        slidesPerView: 2, // 2 items on small screens (>= 776px)
      },
      480: {
        slidesPerView: 1, // 1 item on extra small screens (< 480px)
      },
      330: {
        slidesPerView: 1, // 1 item on extra small screens (< 480px)
      }
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
  

  document.querySelectorAll('.accordion-button').forEach(button => {
    button.addEventListener('click', () => {
        const offset = document.querySelector('.navbar').offsetHeight || 0;
        const target = button.closest('.accordion-item').querySelector('.accordion-collapse');
        if (!target.classList.contains('show')) {
            setTimeout(() => {
                const scrollPosition = target.getBoundingClientRect().top + window.scrollY - offset;
                window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
            }, 300); // Delay to account for collapse animation
        }
    });
});


let offersSection = document.querySelector('.offersSection');

if(offersSection){
  const swiper = new Swiper('.offer-swiper-container', {
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1440: {
        slidesPerView: 4,
        spaceBetween: 40,
      },
    },
  });
}